var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconParkOutlineMessage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 36,
    viewBox: "0 0 35 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.2084 13.6263H23.3334M10.2084 19.4596H23.3334M10.2084 25.293H17.5M32.0834 18.0013C32.0834 26.0557 25.5544 32.5846 17.5 32.5846H2.91669V18.0013C2.91669 9.94693 9.44565 3.41797 17.5 3.41797C25.5544 3.41797 32.0834 9.94693 32.0834 18.0013Z",
    stroke: "white",
    strokeWidth: 2.91667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconParkOutlineMessage);
export default __webpack_public_path__ + "static/media/icon-park-outline_message.6ab78de295d6b468ab250ea7b46879d3.svg";
export { ForwardRef as ReactComponent };